import React from "react";
// Import custom navigation icons from assets folder
import homeIcon from "../../assets/Home.svg";
import mapIcon from "../../assets/Maps.svg";
import communitiesIcon from "../../assets/Communities.svg";
import chatIcon from "../../assets/Chat.svg";

import styles from "./BottomNavBar.module.css";

/**
 * Floating, pill-shaped bottom navigation bar featuring custom icons
 * and active tab indicators.
 */
export function BottomNavBar({
  activeTab,
  selectedEvent,
  handleTabChange,
  matchesCount,
}) {
  // Navigation tabs configuration array
  const tabs = [
    { id: "home", label: "Home", icon: homeIcon },
    { id: "map", label: "Map", icon: mapIcon },
    { id: "communities", label: "Communities", icon: communitiesIcon },
    { id: "chat", label: "Chat", icon: chatIcon },
  ];

  return (
    <div className={styles.navWrapper}>
      <nav className={styles.nav}>
        {tabs.map((tab) => {
          const IconSource = tab.icon;
          const isActive = activeTab === tab.id && !selectedEvent;

          return (
            <button
              key={tab.id}
              onClick={() => handleTabChange(tab.id)}
              className={isActive ? styles.tabActive : styles.tabInactive}
            >
              <img
                src={IconSource}
                alt={tab.label}
                className={styles.navIcon}
              />
              <span className={styles.tabLabel}>{tab.label}</span>

              {/* Notification badge for new matches/messages */}
              {tab.id === "chat" && matchesCount > 0 && (
                <span className={styles.matchBadge}>{matchesCount}</span>
              )}
            </button>
          );
        })}
      </nav>
    </div>
  );
}
